import React, { FC, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { Container } from "@mui/material";

import Page from "../../components/Page";

const Cancel: FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const returnUrl = searchParams.get("returnUrl");
    if (returnUrl) {
      location.href = returnUrl;
    }
  }, [searchParams.get("returnUrl")]);

  return (
    <Page title="Cancel">
      <Container maxWidth={false}>Checkout Cancelled</Container>
    </Page>
  );
};
export default Cancel;
